import { charCopy } from "./utilities";

export const alphaMessage = "Pole nie może zawierać cyfr i znaków specjalnych";
export const alphanumericMessage =
  "Pole powinno posiadać tylko znaki alfanumeryczne";
export const emailMessage = "Podaj prawidłowy adres email";
export const maxLengthMessage = (charLength: number): string =>
  `Pole powinno mieć maksymalnie ${charLength} ${charCopy(charLength)}`;
export const minLengthMessage = (charLength: number): string =>
  `Pole powinno mieć minimalnie ${charLength} ${charCopy(charLength)}`;
export const strictLengthMessage = (charLength: number): string =>
  `Pole powinno mieć dokładnie ${charLength} ${charCopy(charLength)}`;
export const numberMessage = "Pole powinno być liczbą";
export const ocMessage = "Niepoprawny numer OC";
export const peselMessage = "Pole powinno być zgodne z formatem NNNNNNNNNNN";
export const phoneMessage =
  "Pole powinno być zgodne z formatem +NN NNN NNN NNN";
export const postalCodeMessage = "Pole powinno być zgodne z formatem NN-NNN";
export const postalCodeGenericMessage =
  "Pole powinno mieć minimalnie 3 znaki; nie może zawierać znaków specjalnych";
export const regonMessage = "Pole powinno zawierać 9 lub 14 cyfr";
export const requiredMessage = "Uzupełnij to pole";
// JIRA LPPLWEBMOB-623
export const requiredCheckboxMessage =
  "Akceptacja jest wymagana do przesłania formularza. W przypadku braku akceptacji prosimy o zgłoszenie szkody w formie telefonicznej bądź listownej.";

export const requiredOptionMessage = "Wybierz dostępną opcję";
export const requiredDateMessage = "Wybierz poprawną datę";
export const requiredTimeMessage = "Wybierz poprawną godzinę";
export const vinMessage = "Numer powinien zawierać 17 znaków, bez I, O, Q.";
export const requiredYearMessage = "Wybierz poprawny rok";
export const excludePolishCharsMessage =
  "Pole nie może zawierać polskich znaków";
